"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hooks_1 = require("preact/hooks");

function useDebounceCallback(callback, time) {
  var inputs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var timer = hooks_1.useRef(null);
  var latestCallback = hooks_1.useRef();
  latestCallback.current = hooks_1.useCallback(callback, inputs);
  return function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(function () {
      latestCallback.current.apply(latestCallback, params);
      timer.current = null;
    }, time);
  };
}

exports.default = useDebounceCallback;